import { DownloadWindowWebComponent } from './component/DownloadWindowWebComponent';
import { WEB_COMPONENT_DOWNLOAD_WINDOW } from '../../webcomponents.constants';

export { DownloadWindowWebComponent };

window.customElements.define(WEB_COMPONENT_DOWNLOAD_WINDOW, DownloadWindowWebComponent);
